/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaPisosVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaPisos: React.FunctionComponent<ITablaPisosVistaProps & InjectedIntlProps> = ({
    pisoss,
    cargarPisos,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={pisoss}
            actions={acciones(manejarFormulario, cargarPisos, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaPisos);
